import MainHeaderComponent from './modules/main-header/main-header';
import BackToTopComponent from './modules/back-to-top/back-to-top';
import { TweenMax } from 'gsap/all';

export default function () {
	if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

  MainHeaderComponent.init();
  BackToTopComponent.init();

  TweenMax.to('#white-overlay', .5, { alpha: 0, onComplete: () => {
    document.querySelector('#white-overlay').style.display = 'none';
  }});
};